import React from 'react';

import RowGrid from "./RowGrid";

import Mensaje from './Mensaje';
import ListJurisdiccion from './ListJurisdiccion';



function ViewSIRCREB({data, anio, mes}) {        

    let vMes = parseInt(mes) < 10 ? '0'+mes : mes;    
    let vCM = data.esConvenio === 'S' ? 1 : 0;        

    const formatCuit =(p_cuit)=>{        
        
         if ( p_cuit.toString().length===11){
            const part1 =  p_cuit.toString().slice(0,2);
            const part2 =  p_cuit.toString().slice(2,10);
            const part3 =  p_cuit.toString().slice(10);
            
            return `${part1}-${part2}-${part3}`;

        }
        return p_cuit;
    }

    /*useEffect(() => {
        console.log('------- entra a use effect ----------------');       
        setcCUIT(data.cuit);
        part1= cCUIT.toString().slice(0,2);
        console.log('valor parte 1: '+ part1);
        console.log('valor de cuit ->'+cCUIT)
        
    },[data]);*/

  return (
    <>  
        {  (data.sistema === 'sircreb' || data.sistema === 'sircupa' ) &&
            <div>
                <RowGrid
                    ancho="3"
                    text1="Régimen:"
                    text2={
                        data.esConvenio == null
                        ? "Local - " +
                        data.padronCtribJur[0].descJurisdiccion
                        : "Convenio Multilateral"
                    }
                />
                <RowGrid ancho="3" text1="Sistema:" text2={data.sistema} />
                <RowGrid ancho="3" text1="CUIT:" text2={formatCuit(data.cuit)} />
                <RowGrid
                    ancho="3"
                    text1="Razón Social:"
                    text2={data.razonSocial}
                />
                <RowGrid
                    ancho="3"
                    text1="Período:"
                    text2={ anio + "/" + vMes}
                />
                <RowGrid
                    ancho="3"
                    text1="Alícuota aplicada:"
                    text2={data.alicuota + " %"}
                /> 
                <ListJurisdiccion data={data} />        
                
                <Mensaje  tipo={vCM} />
                
        </div> 
        }
    </>
  )
}

export default ViewSIRCREB;